export const UPDATE_TAB_OPTIONS = "UPDATE_TAB_OPTIONS";
export const DOWN_TIME_TICKET = "DOWN_TIME_TICKET";
